<template>
    <div>
        <tabs class="tabs-modal" :options="tabOptions">
            <tab class="mt-3" name="Style" tabid="long-short-style">
                <fill :default-value="traits.fill" v-model="form.fill"></fill>
                <fill :default-value="traits.fill2" v-model="form.fill2"></fill>
                <div class="mt-2 mb-2">
                    <compact :default-value="traits.compact" v-model="form.compact"></compact>
                </div>
                <line-component :default-value="traits.line" v-model="form.line"></line-component>
            </tab>
            <tab name="Coordinates" tabid="long-short-coordinates">
                <div class="mt-3 mb-2">
                    <label for="entry-price">
                        Entry Price
                        <price-input id="entry-price" :symbol="symbol" :symbol-type="symbolType" :base-code="baseCode" v-model="form.points[0].price" :default-value="form.points[0].price" class="ml-1" />
                    </label>
                    <label for="upper-price">
                        Upper
                        <price-input id="upper-price" :symbol="symbol" :symbol-type="symbolType" :base-code="baseCode" v-model="form.points[1].price" :default-value="form.points[1].price" class="ml-1" />
                    </label>
                    <label for="lower-price">
                        Lower
                        <price-input id="lower-price" :symbol="symbol" :symbol-type="symbolType" :base-code="baseCode" v-model="form.points[2].price" :default-value="form.points[2].price" class="ml-1" />
                    </label>
                </div>
            </tab>
        </tabs>
        <div class="w-full p-0 mt-3">
            <div class="flex">
                <div @click="emitClone" class="btn btn-sm inline-flex mr-1">Clone Tool</div>
                <div @click="reset" class="btn btn-sm inline-flex ml-1">Reset</div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue';
// import FillText from './FillText';
import Compact from './Compact';
import Fill from './Fill';
import LineComponent from './Line';
import PriceInput from '../../PriceInput';

const props = defineProps({
    initialTraits: Object,
    initialPoints: Array,
    // ShortPostion/LongPosition
    id: String,
    symbol: String
});

const $clone = (obj) => JSON.parse(JSON.stringify(obj));
const emit = defineEmits(['update:modelValue', 'clone']);

const baseCode = window.Barchart.getFieldFromInlineTemplate('unitCode');
const symbolType = window.Barchart.getFieldFromInlineTemplate('symbolType');

const defaults = {
    compact: false,
    fill: { color: 'rgba(0, 160, 0, 0.2)' },
    fill2: { color: 'rgba(205, 0, 0, 0.2)' },
    line: { color: '#000', dashStyle: 'Solid', width: 1 }
};

const form = ref({
    ...$clone(props.initialTraits),
    points: props.initialPoints
});

const traits = ref(props.initialTraits);

const tabOptions = ref({
    useUrlFragment: false,
    defaultTabHash: null
});

function reset() {
    traits.value = $clone(defaults);
    window.localStorage.removeItem(props.id);
}

function emitClone() {
    emit('clone');
}

watch(form, () => {
    emit('update:modelValue', form.value);
}, { deep: true });
</script>
